/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TimeOffType {
    TIME_OFF = 'TimeOff',
    EXTRA_OFFICE_HOURS = 'ExtraOfficeHours',
}
